import CastForEducationIcon from "@mui/icons-material/CastForEducation";
import { ErasmusServicePath, REGULAR_INCOMING_ERASMUS } from "utils/constants";
import { tenants } from "utils/tenants";
import ListIncomingStudentsRegular from "./List";
import permissions from "app/permissions";
import CreateIncomingRegularStudent from "./Create";
import ShowIncomingRegularStudents from "./Show/Show";

export const resources = {
  isMenu: true,
  icon: <CastForEducationIcon />,
  tenancies: [tenants.MU],
  name: `${ErasmusServicePath}${REGULAR_INCOMING_ERASMUS}`,
  title: "Пристигащи студенти за обучение и BIP",
  list: <ListIncomingStudentsRegular />,
  create: <CreateIncomingRegularStudent />,
  show: <ShowIncomingRegularStudents />,
  permission: permissions.canPreviewErasmusRegularStudents,
  createPermission: permissions.canManageErasmusRegularStudents,
  showPermission: permissions.canPreviewErasmusRegularStudents,
};
